import React from 'react';
import { Autocomplete, TextField, Checkbox } from '@mui/material';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export interface VendorOption {
    id: string;
    name: string;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const ALL_OPTION: VendorOption = {
    id: '__all__',
    name: 'SELECT ALL'
};

interface Props {
    options: VendorOption[];
    value: string[];
    sx?: any;
    onChange: (vendorIds: string[]) => void;
}

export default function VendorSelector({
    options,
    value,
    sx,
    onChange
}: Props) {
    const allVendorIds = options
        .filter(o => o.id !== ALL_OPTION.id)
        .map(o => o.id);

    const safeValue = value ?? [];

    const isAllSelected = safeValue.length === allVendorIds.length;

    const mergedOptions = [ALL_OPTION, ...options];

    return (
        <Autocomplete
            multiple
            fullWidth
            options={mergedOptions}
            disableCloseOnSelect
            getOptionLabel={(o) => o.name}
            value={mergedOptions.filter(v => safeValue.includes(v.id))}
            isOptionEqualToValue={(option, selected) => option.id === selected.id}
            onChange={(_, newValue) => {
                const clickedAll = newValue.some(v => v.id === ALL_OPTION.id);

                if (clickedAll) {
                    onChange(isAllSelected ? [] : allVendorIds);
                    return;
                }

                onChange(newValue.map(v => v.id));
            }}
           renderOption={(props, option) => {
                const checked =
                    option.id === ALL_OPTION.id
                        ? isAllSelected
                        : value.includes(option.id);

                return (
                    <li {...props}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={checked}
                            sx={{ mr: 1 }}
                        />
                        {option.name}
                    </li>
                );
            }}
            renderInput={(params) => (
                <TextField {...params} fullWidth label="Vendor(s)" />
            )}
        />
    );
}